import { useEffect, useState } from 'react'

import { ServerError } from '../types/server-error'

export function useGlobalError() {
  const [error, setError] = useState<ServerError | Error | null>(null)

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      event.preventDefault()
      setError(event.error || new Error(event.message))
    }

    const handleRejection = (event: PromiseRejectionEvent) => {
      event.preventDefault()
      setError(event.reason || new Error('Unhandled promise rejection'))
    }

    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', handleRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleRejection)
    }
  }, [])

  return { error, setError }
}
